module.exports = __webpack_public_path__ + "assets/img/driver-btn-66e53483.png";